import React, { FC } from "react";
import cn from "classnames";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import {
  CORNER_ELEMENT_BEFORE,
  CORNER_ELEMENT_AFTER,
} from "src/constants/cornerElement";
import { ReactComponent as ArrowIcon } from "src/assets/icons/arrow.svg";
import { IActionCard } from "./types";
import { scrollTo } from "src/utils/scroll";
import { addHash } from "src/utils/hash";
import { SECTION_IDS } from "../constants";

const BUTTON_LABEL_TO_SECTION: Record<string, string> = {
  Послуги: SECTION_IDS.SERVICES,
  Пакети: SECTION_IDS.SERVICE_PACKAGES,
  Команда: SECTION_IDS.TEAM,
};

export const ActionCard: FC<IActionCard> = ({ text, buttonLabel }) => {
  const handleClick = () => {
    const sectionId = BUTTON_LABEL_TO_SECTION[buttonLabel];
    if (sectionId) {
      scrollTo(addHash(sectionId));
    }
  };

  return (
    <div
      className={cn(
        "absolute -bottom-px -right-px bg-white-second rounded-tl-15 border-white-second border-t-10 border-l-10 lg:border-t-20 lg:border-l-20 max-w-56 xs:max-w-80 sm:max-w-102 2xl:max-w-160",
        CORNER_ELEMENT_BEFORE,
        "before:bottom-0 before:-left-8.75 lg:before:-left-11.25 before:shadow-corner-gray-light",
        CORNER_ELEMENT_AFTER,
        "after:right-0 after:-top-8.75 lg:after:-top-11.25 after:shadow-corner-gray-light"
      )}
    >
      <div className="bg-green-gradient rounded-15 px-5 pt-8 pb-4 2xl:p-12.5">
        <p className="text-white-base text-12 sm:text-22">{text}</p>

        <Button
          className="flex items-center gap-3.5 sm:gap-8.5 mt-9"
          variant={ButtonVariants.SECONDARY}
          onClick={handleClick}
        >
          <span>{buttonLabel}</span>
          <ArrowIcon className="w-3.5 sm:w-8 rotate-180" />
        </Button>
      </div>
    </div>
  );
};
